import Header from "../../components/header/Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import SideBar from "../../components/sideBar/SideBar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./remark.css";

const EditRemark = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [formData, setFormData] = useState({
    userId: "",
    name: "",
    email: "",
    mobile: "",
    password: "",
  });

  const handleStatusChange = () => {
    setStatus(!status);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const userDetails = sessionStorage.getItem("adminInfo");
  const userInfo = JSON.parse(userDetails);

  useEffect(() => {
    if (sessionStorage.getItem("adminInfo") === null) {
      navigate("/admin/login");
    }
  }, []);

  //   details api

  useEffect(() => {
    handleEditorDetails();
  }, [id]);

  const handleEditorDetails = async () => {
    const formData = {
      remark_id: id,
    };
    try {
      const response = await axios.post(
        API_BASE_URL + "admin/remark_details",
        formData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("remark details response", response.data);
      if (response.data.status) {
        setFormData({
          name: response.data.data.name,
        });
      }
      if (response.data.data.status === "Y") {
        setStatus(!status);
      } else {
        setStatus(status);
      }
    } catch (error) {
      console.log("errror occured fetching data", error);
    }
  };

  // edit auditor api

  const handleEditAuditor = async (event) => {
    event.preventDefault();
    const { name } = formData;
    try {
      const finalData = {
        remark_id: id,
        name: name,
        status: status ? "Y" : "N",
      };
      // console.log("update remark finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "admin/update_remark",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("update remark response", response.data);
      if (response.data.status) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/admin/manage-remark");
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <Header />
      <section className="auditorMain">
        <SideBar />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="auditorDataTableBox">
                <div className="auditorTitleBox">
                  <h5>Edit Remark</h5>
                </div>
                <div className="auditorMainFormSec">
                  <form
                    className="addAuditorForm"
                    name="addAuditor"
                    id="addAuditor"
                    onSubmit={handleEditAuditor}
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="auditorGroup">
                          <label htmlFor="">Name :-</label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="auditorGroup">
                          <label htmlFor="">Status :-</label>
                          <input
                            type="checkbox"
                            checked={status}
                            onChange={handleStatusChange}
                            className=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="auditorBtnGroup">
                          <button className="btn">Save</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer
            position={"top-right"}
            autoClose={2000}
            pauseOnHover={false}
            closeOnClick={true}
          />
        </div>
      </section>
    </>
  );
};

export default EditRemark;
